module.exports = __webpack_public_path__ + "static/media/str-chat__reaction-list-sprite@1x.1180c721.png";